'use client';

import { Logo } from '@/components/icons';
import { CloseIconThin } from '@/components/icons';
import { LoginForm } from '@/components/forms/login/LoginForm';
import { RegisterForm } from '@/components/forms/register/RegisterForm';
import { TUserType } from '@/types';
import { useAuthModal } from '@/lib/context/AuthModalContext';

interface IUserAuthForm {
  handleClose: () => void;
}

export const UserAuthForm = ({ handleClose }: IUserAuthForm) => {
  const { formType, switchForm } = useAuthModal();

  return (
    <div>
      <div className="flex flex-row justify-end items-end px-4">
        <div className="modal__close cursor-pointer" onClick={handleClose}>
          <CloseIconThin />
        </div>
      </div>

      {formType === 'login' ? <LoginForm handleClose={handleClose} /> : <RegisterForm handleClose={handleClose} />}

      <div className="text-md flex flex-row gap-1 justify-center border-t border-gray-800 px-4 pt-6 pb-2">
        {formType === 'login' && (
          <>
            <span>Not a member yet?</span>
            <span className="font-semibold cursor-pointer" onClick={switchForm}>
              Create an account
            </span>
          </>
        )}

        {formType === 'register' && (
          <>
            <span>Already a member?</span>
            <span className="font-semibold cursor-pointer" onClick={switchForm}>
              Sign in
            </span>
          </>
        )}
      </div>
    </div>
  );
};
